function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
export var JsonUtils = /*#__PURE__*/ function() {
    "use strict";
    function JsonUtils() {
        _class_call_check(this, JsonUtils);
    }
    _create_class(JsonUtils, null, [
        {
            key: "stringify",
            value: function stringify(value) {
                var indent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                try {
                    if (_instanceof(value, Error)) {
                        var errorValue = {
                            name: value.name,
                            message: value.message,
                            stack: value.stack
                        };
                        return JsonUtils.stringify(errorValue, indent);
                    }
                    return JSON.stringify(value, JsonUtils.circularReferencesHandler(), indent);
                } catch (e) {
                    return '';
                }
            }
        },
        {
            key: "parse",
            value: function parse(json, reviver) {
                try {
                    return JSON.parse(json, reviver);
                } catch (e) {
                    return null;
                }
            }
        },
        {
            key: "objToKeyValuePair",
            value: /**
     * Given a flat object, convert it to a string key-value pair object
     * @param obj
     * @returns
     */ function objToKeyValuePair(obj) {
                return Object.keys(obj).reduce(function(acc, key) {
                    /**
             * Typescript makes this a bit gross, but if the value is already a string, no conversion is necessary
             * If the value is anything else, stringify it
             */ acc[key.toString()] = typeof obj[key] === 'string' ? obj[key] : JsonUtils.stringify(obj[key]);
                    return acc;
                }, {});
            }
        },
        {
            key: "circularReferencesHandler",
            value: function circularReferencesHandler() {
                var seen = new WeakSet();
                return function(_, value) {
                    if ((typeof value === "undefined" ? "undefined" : _type_of(value)) === 'object' && value !== null) {
                        if (seen.has(value)) {
                            return '[circular reference]';
                        }
                        seen.add(value);
                    }
                    return value;
                };
            }
        }
    ]);
    return JsonUtils;
}();

//# sourceMappingURL=json-utils.js.map